module.exports = __webpack_public_path__ + "static/media/icon_161.f2783b5e.svg";